module.exports = __webpack_public_path__ + "static/media/fd2.12a7bedb.jpg";